import { render, staticRenderFns } from "./DeleteDialogComponent.vue?vue&type=template&id=05a037f3&scoped=true&"
import script from "./DeleteDialogComponent.vue?vue&type=script&lang=js&"
export * from "./DeleteDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./DeleteDialogComponent.vue?vue&type=style&index=0&id=05a037f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a037f3",
  null
  
)

export default component.exports